module.exports = __webpack_public_path__ + "assets/img/travel-day34.769ca7f7.png";